<template>
    <div ref="fivepointOfficeLocationContainer" class="fivepoint-office-location-container">
        <div class="fivepoint-office-location-map">
            <CommonComponentsSVGAboutUsOfficeLocationMap />
        </div>
    </div>
    <div class="fivepoint-office-location-detail global-limited-1360px-container">
        <div class="fivepoint-office-location-inner">
            <div
                v-for="(textItem, textIndex) in data.TextList"
                :key="textIndex"
                :class="`fivepoint-office-info-item-${textIndex}`"
            >
                <div v-if="textItem.title" class="mini-title">
                    {{ $t(textItem.title) }}
                </div>
                <div
                    :class="`content-${textIndex}`"
                    class="fivepoint-office-location-subtitle"
                    v-html="$t(textItem.subtitle)"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    import { matchMobile } from '~~/composables/useMatchRules.ts';
    import { ifCNLocale } from '~~/composables/useLocale.ts';

    gsap.registerPlugin(ScrollTrigger);

    const data = reactive({
        TextList: [
            {
                title: 'global_aboutus_introduction_fivepoint_office_location_title1',
                subtitle: 'global_aboutus_introduction_fivepoint_office_location_subtitle1',
            },
            {
                title: 'global_aboutus_introduction_fivepoint_office_location_title2',
                subtitle: 'global_aboutus_introduction_fivepoint_office_location_subtitle2',
            },
            {
                title: 'global_aboutus_introduction_fivepoint_office_location_title3',
                subtitle: 'global_aboutus_introduction_fivepoint_office_location_subtitle3',
            },
            {
                // title: ' ',
                subtitle: 'global_aboutus_introduction_fivepoint_office_location_subtitle4',
            },
        ],
    });
    const fivepointOfficeLocationContainer = ref(null);

    onMounted(() => {
        const content1 = document.querySelector('.fivepoint-office-location-inner .content-1 ') as HTMLElement;
        // console.log(content1);
        const brRegExp = new RegExp('<br>', 'g');
        const ifMatched = matchMobile();
        const isCN = ifCNLocale();
        // 中文移动端去除 <br>
        if (ifMatched && isCN) {
            content1.innerHTML = content1.innerHTML.replace(brRegExp, '、');
        }
        addTextScrollLine('.content-3,.content-2,.content-1'); // addTextScrollLine

        // 地图-----
        const svgElement = document.querySelector('.fivepoint-office-location-map') as HTMLElement;
        const element = document.querySelectorAll('.svg-map .line,.svg-map .text'); // point
        const allArray = gsap.utils.toArray(element) as Array<HTMLElement>;
        // console.log('allArray',allArray);
        const element2 = document.querySelectorAll('.svg-map .text-star,.svg-map .line-star'); // star
        const main = gsap.utils.toArray(element2) as Array<HTMLElement>;
        const star = document.querySelector('.svg-map .star') as HTMLElement;
        const circleEle = document.querySelectorAll('.svg-map circle');
        const circle = gsap.utils.toArray(circleEle) as Array<HTMLElement>;
        // console.log(circle);

        // console.log('star',star);

        const all = allArray.concat(main);
        // console.log('mian',main);
        // ——————————

        let x = 0;
        let y = 0;
        let scale = 1;
        let count = 0;
        const mapWidth = svgElement.offsetWidth;
        const mapHeight = svgElement.offsetHeight;
        const minScale = 1;
        const maxScale = 2.8;
        all.forEach((item) => {
            item.style.opacity = '0';
        });
        circle.forEach((item) => {
            item.style.opacity = '0';
        });
        star.style.opacity = '1';

        svgElement.addEventListener('mousedown', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // if(e.button === 0) {
            //     // 鼠标左键按下
            //     console.log('左键按下');
            // } else if (e.button === 2) {
            //     // 鼠标右键按下
            //     console.log('右键按下');
            // }
        });
        // 禁用浏览器的右键菜单
        // svgElement.addEventListener('contextmenu', function(event) {
        //     event.preventDefault();
        // });
        // 地图缩放
        svgElement.addEventListener('mousedown', function (e) {
            // wheel
            let ratio = 2.8; // 放大比例
            if (e.button === 0) {
                count++;
                // console.log('count',count);
                if (count % 2 === 0) {
                    // 偶数次 缩小 //||e.button===2
                    // console.log('缩小');
                    ratio = 1 / 2.8;
                }
            }
            // 限制缩放倍数
            const onscale = scale * ratio;
            if (onscale > maxScale) {
                ratio = maxScale / scale;
                scale = maxScale;
            } else if (onscale < minScale) {
                ratio = minScale / scale;
                scale = minScale;
            } else {
                scale = onscale;
            }

            const origin = {
                x: (ratio - 1) * mapWidth * 0.5,
                y: (ratio - 1) * mapHeight * 0.5,
            };
            // console.log('x',x,'y',y);

            x -= (ratio - 1) * (e.clientX - x - (window.innerWidth - mapWidth) * 0.1) - origin.x;
            y -= (ratio - 1) * (e.clientY - y) - origin.y;
            // console.log('x2',x,'y2',y);
            // console.log(scale);
            // console.log(mapWidth - (mapWidth * (scale + 1)) / 2);

            const offsetX = Math.min(
                Math.max(x, mapWidth - (mapWidth * (scale + 1)) / 2),
                (mapWidth * (scale - 1)) / 2,
            );
            const offsetY = Math.min(
                Math.max(y, mapHeight - (mapHeight * (scale + 1)) / 2),
                (mapHeight * (scale - 1)) / 2,
            );
            x = offsetX;
            y = offsetY;
            // console.log('offsetX:',offsetX,'offsetY:',offsetY);
            // console.log('window.innerWidth',window.innerWidth,'window.innerHeight',window.innerHeight);

            // svgElement.style.transform = `matrix(${scale}, 0, 0, ${scale}, ${offsetX}, ${offsetY})`;
            // svgElement.style.transition = 'transform 0.3s';

            if (!fivepointOfficeLocationContainer.value) return;
            const mapPos = fivepointOfficeLocationContainer.value.getBoundingClientRect();
            console.log(mapPos, e.clientX, e.clientY);

            let originX = e.clientX - mapPos.left;
            const originY = e.clientY - mapPos.top;
            console.log(originX, originY);
            if ((originX * 100) / mapPos.width < 20) originX = 0; // 把德国意大利的城市名显示全
            svgElement.style.transform = `scale(${scale}, ${scale})`;
            svgElement.style.transformOrigin = `${originX}px ${originY}px`;
            svgElement.style.transition = 'transform 0.3s';
        });

        // 文字效果
        svgElement.addEventListener('mousedown', function (e) {
            // wheel
            e.preventDefault();
            if (scale >= 2.8) {
                main.forEach((item) => {
                    item.style.opacity = '1';
                    item.style.transition = 'opacity .3s';
                });
                allArray.forEach((item) => {
                    item.style.opacity = '1';
                    item.style.transition = 'opacity 1s 0.5s';
                });
            } else {
                main.forEach((item) => {
                    item.style.opacity = '0';
                    item.style.transition = 'opacity .3s';
                });
                allArray.forEach((item) => {
                    item.style.opacity = '0';
                    item.style.transition = 'opacity .3s';
                });
            }
        });
        // gsap动画
        ScrollTrigger.create({
            // markers: { startColor: 'green', endColor: 'red', fontSize: '12px' },
            trigger: '.fivepoint-office-location-map',
            scrub: true,
            start: '60% 80%',
            end: '70% 80%',
            animation: gsap
                .timeline()
                .to('.svg-map .point', {
                    fill: '#00ffff ',
                })
                // .set('.svg-map circle',{
                //     opacity: 0
                // })
                .to(circle, {
                    opacity: 0.1,
                }),
        });
        gsap.fromTo(
            star,
            {
                scale: 1,
                opacity: 0.5,
            },
            {
                scale: 1.4,
                repeat: -1,
                transformOrigin: 'center',
                opacity: 1,
                yoyo: true,
            },
        );
    });
</script>

<style lang="less" scoped>
    .fivepoint-office-location-container {
        overflow: hidden;
        .fivepoint-office-location-map {
            // width: 100%;
            overflow: hidden;
            // display: flex;
            :deep(.svg-map) {
                //#0032FF  #262626
                position: relative;
                z-index: 0;
                .point {
                    fill: #333333;
                }
                .star {
                    // fill: #333333;
                    position: absolute;
                    z-index: 10;
                }
                circle {
                    cursor: pointer;
                }
            }
            @media (max-width: @screen-mobile-width) {
                display: none;
            }
        }
    }
    .fivepoint-office-location-detail {
        display: flex;
        margin-top: .convert(20px) [ @vw];
        white-space: nowrap;
        font-family: 'HarmonyOS Sans SC';
        .fivepoint-office-location-inner {
            // margin: 0 auto;
            width: 100%;
            display: flex;
            border-radius: 20px;
            background: #161616;
            padding: .convert(40px) [ @vw] .convert(146px) [ @vw];
            @media (max-width: @screen-mobile-width) {
                flex-direction: column;
                padding: .convert(30px) [ @vw-mobile] .convert(22px) [ @vw-mobile];
            }

            .fivepoint-office-info-item-1 {
                margin-left: .convert(100px) [ @vw];
            }
            .fivepoint-office-info-item-2 {
                margin-left: .convert(200px) [ @vw];
            }
            .fivepoint-office-info-item-3 {
                margin-left: .convert(80px) [ @vw];
            }
            @media (max-width: @screen-mobile-width) {
                .fivepoint-office-info-item-1,
                .fivepoint-office-info-item-2,
                .fivepoint-office-info-item-3 {
                    margin-left: 0;
                }
            }
            .mini-title {
                color: #d6d6d6;
                font-size: .convert(@font-size-lg-ssm) [ @vw]; //16px
                line-height: normal;
                margin-bottom: .convert(23px) [ @vw];
                font-family: Montserrat;

                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(12px) [ @vw-mobile];
                    margin-bottom: .convert(10px) [ @vw-mobile];
                }
            }
            .fivepoint-office-location-subtitle {
                font-size: .convert(20px) [ @vw]; //16px -> 20px
                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(16px) [ @vw-mobile];
                }
            }
            .content-0 {
                font-size: .convert(@font-size-title-xs) [ @vw]; //36px
                margin-top: .convert(47px) [ @vw];
                line-height: normal;
                width: auto;
                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(@font-size-xl) [ @vw-mobile]; //24px
                    margin-top: 0;
                }
            }
            .content-3 {
                transform: translateY(.convert(45px) [ @vw]);
                @media (max-width: @screen-mobile-width) {
                    transform: translateY(0);
                }
            }

            @media (max-width: @screen-mobile-width) {
                .content-0,
                .content-1 {
                    margin-bottom: .convert(30px) [ @vw-mobile];
                }
            }
        }
    }
</style>
